import { render, staticRenderFns } from "./ProgramasPersona.vue?vue&type=template&id=453d5738"
import script from "./ProgramasPersona.vue?vue&type=script&lang=js"
export * from "./ProgramasPersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports